module.exports = __webpack_public_path__ + "static/media/cu04_ch01.2d9c4e11.png";